<template lang="pug" src="./brands.pug"></template>
<style lang="scss" src="./brands.scss" scoped></style>

<script>
import { mapState, mapGetters } from 'vuex';
import request from '@/utils/request';

export default {
    data: () => ({
        requestProcessing: false,
        removeDialog: false,
        cannotRemoveDialog: false,
        removeId: null,
        showRemoved: false,
        filters: {
            query: null,
            type: null
        }
    }),
    computed: {
        ...mapGetters(['roleName', 'userBrandId']),
        ...mapState({
            items: state => state.brands.items,
            pagination: state => state.brands.pagination
        }),
        headers() {
            const titles = ['code', 'title', 'domain', 'phoneNumber', 'defaultOptionId', 'fromCurbOptionId', 'tax', 'is_vip'];

            if (['admin', 'admin-delivery'].includes(this.roleName)) {
                titles.push('actions');
            }

            return titles.map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Brands.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        isRemoved() {
            return this.filters.type === 'removed';
        }
    },
    created() {
        this.loadItems();
    },
    methods: {
        loadItems(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('brands/getItems', Object.assign({}, {
                page,
                ...this.filters
            })).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });
        },

        openCannotRemoveDialog() {
            this.cannotRemoveDialog = true;
        },

        onTypeChange(value) {
            const type = value ? 'removed' : 'active';
            this.$set(this.filters, 'type', type);

            this.loadItems();
        },

        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        },

        openRemoveDialog(id) {
            this.removeDialog = true;
            this.removeId = id;
        },

        async remove() {
            await request({
                method: 'delete',
                url: `/admin/brands/${this.removeId}`
            }).then(res => {
                if (res.status === 204) {
                    this.removeId = null;
                    this.removeDialog = false;

                    this.loadItems();
                }
            }).catch(error => this.errorHandler(error));
        },

        async restore(id) {
            await request({
                method: 'patch',
                url: `/admin/brands/${id}`,
                data: { paranoid: false }
            }).then(res => {
                if (res.status === 204) {
                    this.loadItems();
                }
            }).catch(error => this.errorHandler(error));
        },

        errorHandler(error) {
            const message = error.response && error.response.data && error.response.data.error;

            if (message) {
                this.$store.dispatch('alert/addMessage', {
                    type: 'error',
                    message: `brand.${message}`
                });
            }
        }
    }
};
</script>
